import { __awaiter, __rest } from "tslib";
/**
 * 报表创建/编辑/复制
 */
import React from 'react';
import { createStore } from '@souche-f2e/muji';
import { notification } from 'antd';
import API from '@/services';
import { setKey } from '@/shared/functions';
import { dispatch, getState } from '@@/store';
import { dealDateToTableData } from '@/pages/DataStatistics/ReportList/ReportCreate/_components/function';
let dataRequestParams = null;
const listData = {
    sessionStatic: [
        {
            value: 'aucTimes',
            label: '拍卖场次数',
        },
    ],
    dealData: [
        {
            value: 'aucCarCnt',
            label: '参拍车辆数',
        },
        {
            value: 'aucCnt',
            label: '参拍台次',
        },
        {
            value: 'bidAucCnt',
            label: '出价台次',
        },
        {
            value: 'bidTimes',
            label: '出价次数',
        },
        {
            value: 'bidRate',
            label: '出价率',
        },
        {
            value: 'dealCarCnt',
            label: '成交车辆数',
        },
        {
            value: 'dealOrderCnt',
            label: '成交订单数',
        },
        {
            value: 'dealRate',
            label: '成交率',
        },
        {
            value: 'pendingDealCnt',
            label: '待成交数',
        },
        {
            value: 'outAucCnt',
            label: '流拍数',
        },
        {
            value: 'coupDealOrderCnt',
            label: '撮合成交订单数',
        },
        {
            value: 'disptOrderCnt',
            label: '争议订单数',
        },
        {
            value: 'rtnOrderCnt',
            label: '退车订单数',
        },
        {
            value: 'onSiteDealCnt',
            label: '现场成交数',
        },
        {
            value: 'intnetDealCnt',
            label: '网络成交数',
        },
        {
            value: 'noBidCnt',
            label: '零出价数',
        },
    ],
    goldData: [
        {
            value: 'dealOrderAmt',
            label: '成交订单金额',
        },
        {
            value: 'rtnOrderAmt',
            label: '退车订单金额',
        },
        {
            value: 'premAmt',
            label: '溢价金额',
        },
        {
            value: 'premRate',
            label: '溢价率',
        },
        {
            value: 'reserPremAmt',
            label: '保留溢价金额',
        },
        {
            value: 'reserPremRate',
            label: '保留溢价率',
        },
        {
            value: 'carDealAvgPrice',
            label: '单车成交均价',
        },
        {
            value: 'dealOrderInc',
            label: '成交订单收入',
        },
        {
            value: 'rtnOrderInc',
            label: '退车订单收入',
        },
        {
            value: 'carInc',
            label: '单车收入',
        },
        {
            value: 'comm',
            label: '佣金',
        },
        {
            value: 'netInc',
            label: '净收入',
        },
    ],
    buyerData: [
        {
            value: 'bidMemCnt',
            label: '出价会员数',
        },
        {
            value: 'totMemCnt',
            label: '总会员数',
        },
        {
            value: 'attenMemCnt',
            label: '关注会员数',
        },
        {
            value: 'noLocOrgDealMemCnt',
            label: '非本机构成交会员数',
        },
        {
            value: 'noLocOrgBidMemCnt',
            label: '非本机构出价会员数',
        },
        {
            value: 'locOrgDealMemCnt',
            label: '本机构成交会员数',
        },
        {
            value: 'locOrgBidMemCnt',
            label: '本机构出价会员数',
        },
    ],
    // 车商维度
    dealDataCar: [
        {
            value: 'attenTimes',
            label: '关注台次',
        },
        {
            value: 'aucCnt',
            label: '参拍台次',
        },
        {
            value: 'dealOrderCnt',
            label: '成交订单数',
        },
        {
            value: 'brkContrOrderCnt',
            label: '违约订单数',
        },
        {
            value: 'bidTimes',
            label: '出价次数',
        },
    ],
    sellerData: [
        {
            value: 'buyerName',
            label: '买家姓名',
            disabled: true,
        },
        {
            value: 'phonNum',
            label: '手机号',
        },
        {
            value: 'availSecuDept',
            label: '可用保证金',
        },
        {
            value: 'freezSecuDept',
            label: '冻结保证金',
        },
        {
            value: 'secuDeptTotBal',
            label: '保证金总额',
        },
        {
            value: 'realNameAuthDt',
            label: '认证时间',
        },
        {
            value: 'fstRecrgeSecuDeptDt',
            label: '首次充保时间',
        },
        {
            value: 'buyerState',
            label: '买家状态',
        },
        {
            value: 'maintMan',
            label: '维护人',
        },
    ],
};
const keyValue = {
    startDt: '日期',
    sessNum: '场次编号',
    sessName: '场次名称',
    serialNumber: '序列',
}; // key-value对应表
[...listData.sessionStatic, ...listData.dealData, ...listData.goldData, ...listData.buyerData, ...listData.dealDataCar, ...listData.sellerData].forEach(({ value, label }) => {
    keyValue[value] = label;
});
const keyRender = {
    startDt: (start, rowData) => {
        if (rowData.isOver) {
            return (<div style={{
                height: '21px',
                overflow: 'visible',
                position: 'relative',
                top: '-14px',
            }}>
          <div>...</div>
          <div>预览省略中间日期</div>
        </div>);
        }
        return start;
    },
};
const initData = {
    // desc 场次相关数据
    sessionType: [
        {
            value: '全部',
            keyName: '',
        },
    ],
    sessionTableColumns: [
        {
            title: '场次编号',
            dataIndex: 'sessNum',
            width: 150,
        },
        {
            title: '场次名称',
            dataIndex: 'sessName',
        },
        {
            title: '场次开始时间',
            dataIndex: 'sessStartDt',
            width: 180,
        },
    ],
    sessionTableData: [],
    sessionPageIndex: 0,
    sessionPageSize: 10,
    sessionDataTotal: 0,
    sessionMaxCheckedNum: 10,
    sessionCode: '',
    showSessionCheck: false,
};
const resetData = {
    reportConfigId: null,
    // desc 报表配置相关数据
    reportFormName: null,
    dataDimension: 1,
    startTime: null,
    endTime: null,
    auctionMode: '',
    roundCodeList: [],
    listDisplayItems: [],
    sessionCheckedList: [],
    // desc 预览信息
    showPreView: false,
    preViewTableData: [],
    preViewTableColumns: [],
    // desc 记忆数据
    memoryData1: {
        formData: {
            statisticalDimension: 1,
            auctionMode: '',
        },
        tableColumns: [],
        tableData: [],
        listDisplayItems: ['startDt'],
        minShow: 2,
    },
    memoryData2: {
        formData: {},
        tableColumns: [],
        tableData: [],
        listDisplayItems: ['sessNum', 'sessName'],
        minShow: 3,
    },
    memoryData3: {
        formData: {
            statisticalDimension: 5,
        },
        tableColumns: [],
        tableData: [],
        listDisplayItems: ['serialNumber', 'buyerName'],
        minShow: 3,
    },
    copyData: {},
    sessionCheckedListModal: [],
    // desc 查看报表
    showReport: false,
    reportShowId: null,
    reportColumns: [],
    reportTableData: [],
    reportCurrent: 0,
    reportPageSize: 10,
    reportTableTotal: 0,
    reportStatus: null,
    reportFormUrl: null,
};
export default createStore({
    state: Object.assign(Object.assign(Object.assign({}, initData), resetData), listData),
    effects: {
        // desc 切换数据维度
        changeDataDimension(val, { state }) {
            const memoryData = state[`memoryData${val}`];
            const showColumns = memoryData.tableColumns;
            const showList = memoryData.listDisplayItems;
            const showTableData = memoryData.tableData.slice(0);
            const showPreView = showColumns.length >= memoryData.minShow;
            this.SET_STATE({
                listDisplayItems: showList,
                preViewTableColumns: showColumns,
                showPreView,
                preViewTableData: showTableData,
            });
        },
        // desc 获取场次类型
        getSessionType(params, { state }) {
            const { sessionType } = state;
            API.base.getKeyValue({
                typeId: 28,
            })
                .then((res) => {
                this.SET_STATE({
                    sessionType: setKey([...sessionType, ...res]),
                });
            });
        },
        // desc 切换列表展示列（分开展示）
        changeShowItem({ itemKey, checked }, { state }) {
            const { dataDimension, } = state;
            const memoryData = state[`memoryData${dataDimension}`];
            let showColumns = memoryData.tableColumns.slice(0);
            let showList = memoryData.listDisplayItems.slice(0);
            const minShow = memoryData.minShow;
            dataDimension === 3 && dataRequestParams && this.queryCarBusiness(Object.assign({}, dataRequestParams));
            if (checked) {
                showList.push(itemKey);
                if (showColumns.length === 0) {
                    const tableColumns = showList.map((key) => {
                        return {
                            title: keyValue[key],
                            dataIndex: key,
                            align: 'center',
                            render: keyRender[key] ? keyRender[key] : undefined,
                        };
                    });
                    showColumns.push(...tableColumns);
                }
                else {
                    showColumns.push({
                        title: keyValue[itemKey],
                        dataIndex: itemKey,
                        align: 'center',
                        render: keyRender[itemKey] ? keyRender[itemKey] : undefined,
                    });
                }
            }
            else {
                showList = showList.filter((key) => itemKey !== key);
                showColumns = showColumns.filter(({ dataIndex }) => itemKey !== dataIndex);
            }
            this.SET_STATE({
                [`memoryData${dataDimension}`]: Object.assign({}, memoryData, {
                    tableColumns: showColumns,
                    listDisplayItems: showList,
                }),
                listDisplayItems: showList,
                preViewTableColumns: showColumns,
                showPreView: showColumns.length >= minShow,
            });
        },
        // desc 复制报表时，根据选中展示列 处理预览表格列
        setTableColumns(params, { state }) {
            const { listDisplayItems, dataDimension } = state;
            const memoryData = state[`memoryData${dataDimension}`];
            this.dealTableColumns((colums) => {
                this.SET_STATE({
                    [`memoryData${dataDimension}`]: Object.assign({}, memoryData, {
                        tableColumns: colums,
                        listDisplayItems,
                    }),
                    preViewTableColumns: colums,
                    showPreView: dataDimension === 1 ? colums.length > 1 : colums.length > 0,
                });
            });
        },
        // desc 复制报表
        copyReport(id, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                this.SET_STATE({
                    reportConfigId: id,
                });
                yield this.getReportDetail(id);
                this.setTableColumns({});
                this.setTableData({});
            });
        },
        // desc 处理表格数据
        setTableData(params, { state }) {
            const { dataDimension, sessionCheckedList } = state;
            const memoryData = state[`memoryData${dataDimension}`];
            const formData = memoryData.formData;
            const startTime = formData[`startTime${dataDimension}${formData.statisticalDimension}`];
            const endTime = formData[`endTime${dataDimension}${formData.statisticalDimension}`];
            switch (dataDimension) {
                case 1:
                    if (startTime && endTime) {
                        let tableData = [];
                        tableData = dealDateToTableData({
                            start: startTime,
                            end: endTime,
                            dateType: memoryData.formData.statisticalDimension,
                        });
                        this.SET_STATE({
                            preViewTableData: tableData,
                            [`memoryData${dataDimension}`]: Object.assign({}, memoryData, {
                                tableData,
                            }),
                        });
                    }
                    break;
                case 2:
                    this.SET_STATE({
                        preViewTableData: sessionCheckedList,
                        [`memoryData${dataDimension}`]: Object.assign({}, memoryData, {
                            tableData: sessionCheckedList,
                        }),
                    });
                    break;
                case 3:
                    memoryData.statisticalDimension !== 5 && this.queryCarBusiness({
                        startDate: startTime,
                        endDate: endTime,
                        callback: (res) => {
                            this.SET_STATE({
                                preViewTableData: res,
                                [`memoryData${dataDimension}`]: Object.assign({}, memoryData, {
                                    tableData: res,
                                }),
                            });
                        },
                    });
                    break;
            }
        },
        // desc 处理表头
        dealTableColumns(callback, { state }) {
            const { listDisplayItems } = state;
            const showList = listDisplayItems;
            const showLength = showList.length;
            const colums = [];
            if (showLength > 0) {
                showList.forEach((key, index) => {
                    colums[index] = {
                        title: keyValue[key],
                        dataIndex: key,
                        align: 'center',
                        render: keyRender[key] ? keyRender[key] : undefined,
                    };
                });
            }
            callback && callback(colums);
        },
        // desc 获取场次数据
        getSessionList({ sessionCodeParams, pageIndex }, { state }) {
            const { sessionPageIndex, sessionPageSize, sessionCode } = state;
            const requestIndex = pageIndex ? pageIndex : sessionPageIndex + 1;
            API.report.roundListQuery({
                pageIndex: requestIndex,
                pageSize: sessionPageSize,
                sessNum: sessionCodeParams ? sessionCodeParams : sessionCode,
                tentNum: getState().userInfo.user.tenantCode || '',
            })
                .then((res) => {
                const { items = [], totalNumber = 0 } = res || {};
                this.SET_STATE({
                    sessionTableData: setKey(items),
                    sessionDataTotal: totalNumber,
                    sessionPageIndex: requestIndex,
                });
            });
        },
        // desc 打开场次选择框
        openSessionCheck(params, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.getSessionList({});
                const { sessionCheckedList } = state;
                const showChecked = sessionCheckedList.slice(0);
                this.SET_STATE({
                    sessionCheckedListModal: showChecked,
                    showSessionCheck: true,
                });
            });
        },
        // desc 确定选择选中的场次
        confirmCheckedSession(params, { state }) {
            const { sessionCheckedListModal, memoryData2 } = state;
            const showChecked = sessionCheckedListModal.slice(0);
            this.SET_STATE({
                sessionCheckedList: showChecked,
                showSessionCheck: false,
                sessionCheckedListModal: initData.sessionCheckedListModal,
                sessionPageIndex: initData.sessionPageIndex,
                sessionDataTotal: initData.sessionDataTotal,
                sessionTableData: initData.sessionTableData,
                memoryData2: Object.assign(Object.assign({}, memoryData2), { tableData: showChecked }),
                preViewTableData: showChecked,
            });
        },
        // desc 未确定选择关闭场次弹窗
        cancelCheckedSession() {
            this.SET_STATE({
                showSessionCheck: false,
                sessionTableData: initData.sessionTableData,
                sessionPageIndex: initData.sessionPageIndex,
                sessionDataTotal: initData.sessionDataTotal,
            });
        },
        // desc 取消选择已展示的场次
        cancelHasShowSession(cancelList, { state }) {
            const { sessionMaxCheckedNum, sessionCheckedList, memoryData2, } = state;
            if (cancelList.length === sessionMaxCheckedNum) {
                this.SET_STATE({
                    sessionCheckedList: [],
                });
                return;
            }
            const cancelCodeList = cancelList.map((item) => {
                return item.sessNum;
            });
            const checkedRows = sessionCheckedList.filter((item) => {
                return !cancelCodeList.includes(item.sessNum);
            });
            this.SET_STATE({
                sessionCheckedList: checkedRows,
                memoryData2: Object.assign({}, memoryData2, {
                    tableData: checkedRows,
                }),
                preViewTableData: checkedRows,
            });
        },
        // desc 查看报表
        showReport(id, { state }) {
            return __awaiter(this, void 0, void 0, function* () {
                this.SET_STATE({
                    reportShowId: id,
                });
                yield this.getReportDetail(id);
                this.showReportIndex(1);
                this.dealTableColumns((tableColums) => {
                    this.SET_STATE({
                        showReport: true,
                        reportColumns: tableColums,
                    });
                });
            });
        },
        // desc 报表查看分页查询
        showReportIndex(index, { state }) {
            const { reportPageSize, reportShowId, dataDimension, } = state;
            API.report.reportDetail({
                pageIndex: index,
                pageSize: reportPageSize,
                reportFormId: reportShowId,
            })
                .then((res) => {
                const { currentIndex, totalNumber, items, } = res;
                let showData = items;
                if (dataDimension === 3) {
                    showData = items.map((item, itemIndex) => {
                        return Object.assign(Object.assign({}, item), { serialNumber: (index - 1) * 10 + itemIndex + 1 });
                    });
                }
                this.SET_STATE({
                    reportCurrent: currentIndex,
                    reportTableTotal: totalNumber,
                    reportTableData: showData,
                });
            });
        },
        // desc 获取报表详情
        getReportDetail(id, { state }) {
            return API.report.reportConfigDetail(id)
                .then((res) => {
                const { reportFormName, dataDimension, statisticalDimension, startTime, endTime, auctionMode, listDisplayItems, reportFormUrl, status, roundInfoVOList = [], } = res;
                const dealItems = Object.keys(listDisplayItems || {});
                const itemList = [];
                dealItems.forEach((key) => {
                    itemList[listDisplayItems[key]] = key;
                });
                const sessionCheckedList = [];
                roundInfoVOList.forEach((item) => {
                    const { sessNum, sessName, orderIndex } = item;
                    sessionCheckedList[orderIndex] = {
                        sessNum,
                        sessName,
                    };
                });
                const memoryData = state[`memoryData${dataDimension}`];
                const data = {
                    reportFormName,
                    dataDimension,
                    [`memoryData${dataDimension}`]: Object.assign({}, memoryData, {
                        formData: {
                            statisticalDimension,
                            [`startTime${dataDimension}${statisticalDimension}`]: startTime,
                            [`endTime${dataDimension}${statisticalDimension}`]: (dataDimension === 3 && statisticalDimension === 5) ? undefined : endTime,
                            auctionMode,
                        },
                    }),
                    listDisplayItems: itemList,
                    roundCodeList: sessionCheckedList,
                    sessionCheckedList,
                    reportFormUrl,
                    reportStatus: status,
                };
                this.SET_STATE(Object.assign({ copyData: Object.assign({}, data) }, data));
            });
        },
        // desc 重置报表配置
        RESET_REPORT_COMFIG(isUnMount, { state }) {
            const { reportConfigId, copyData } = state;
            if (isUnMount) {
                this.SET_STATE(Object.assign({ sessionType: initData.sessionType }, resetData));
            }
            else {
                if (reportConfigId) {
                    this.SET_STATE(Object.assign({}, copyData));
                    this.setTableColumns({});
                    this.setTableData({});
                }
                else {
                    this.SET_STATE(Object.assign(Object.assign({}, resetData), { reportConfigId }));
                }
            }
        },
        // desc 生成报表
        createReport(data, { state }) {
            const listItem = {};
            data.listDisplayItems.forEach((key, index) => {
                listItem[key] = `${index}`;
            });
            data.listDisplayItems = listItem;
            API.report.createReport(data)
                .then(() => {
                notification.success({
                    message: '报表生成中，请在列表中查看',
                    duration: 1,
                    onClose: () => {
                        dispatch.router.back();
                    },
                });
            });
        },
        // desc 关闭报表查看
        CLOSE_REPORT_VIEW() {
            this.SET_STATE(Object.assign({}, resetData));
        },
        // desc 查询时间段内车商数据
        queryCarBusiness(params, { state }) {
            const { callback } = params, queryParams = __rest(params, ["callback"]);
            const memoryData = state.memoryData3;
            const { statisticalDimension } = memoryData.formData;
            let requestParams = {
                statisticalDimension,
                dataDimension: 3,
            };
            if (statisticalDimension !== 5) {
                requestParams = Object.assign({}, requestParams, {
                    startTime: queryParams.startDate,
                    endTime: queryParams.endDate,
                });
            }
            API.report.queryPreView(requestParams)
                .then((res) => {
                const showData = res.map((item, index) => {
                    const { buyerName } = item;
                    return {
                        buyerName,
                        serialNumber: index + 1,
                    };
                });
                this.SET_STATE({
                    preViewTableData: showData,
                    memoryData3: Object.assign({}, memoryData, {
                        tableData: showData,
                    }),
                });
                callback && callback(showData);
                dataRequestParams = null;
            })
                .catch(() => {
                dataRequestParams = queryParams;
            });
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload).forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
    },
});
